import AppointmentCalendar from '@/components/GwatCalendar/AppointmentCalendar';
import { Step } from './Step';

type Props = {
  isLoading: boolean;
};

const DaSteps = ({ isLoading }: Props) => {
  return (
    <>
      <div className="px-0 md:px-10 pb-0 md:pb-5">
        <Step
          order={1}
          status="complete"
          border="green"
          title="Complete your booking"
          description="All done! You've taken the first & hardest step. Now the fun begins!"
          isLoading={isLoading}
        />
        <Step
          order={2}
          status="complete"
          border="green"
          title="Confirmation email"
          description="In your inbox, you'll find a copy of your booking details and payment receipt to keep handy. If anything is incorrect on either document, please let us know right away."
          isLoading={isLoading}
        />
        <Step
          order={3}
          status="todo"
          border="none"
          title="Welcome call from your dedicated Deal Expert"
          description="<p>We're going to assign you a personal trip coordinator, which we call a Deal Expert. A travel expert to personally look after you from here until you return, ensuring we make this holiday your best yet!</p><p>Your dedicated Deal Expert will double check your details, answer any new questions about this trip, and make sure everything is ok. Then, the countdown to holiday time begins!</p><p><b>Please choose your preferred time below for your Welcome Call.</b></p>"
          excludeUnderline
          isLoading={isLoading}
        />
      </div>
      <div className="px-0 md:px-10 bg-[#FCFCFC] pt-5 md:pt-0 pb-0 md:pb-10 rounded-b-md">
        <AppointmentCalendar />
      </div>
    </>
  );
};

export default DaSteps;
